import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'column nowrap',
      gap: theme.spacing(1),
      padding: 0,

      '& + &': {
        marginTop: 0, // override native MuiMenuItem style
      },

      '&:hover': {
        backgroundColor: 'unset',

        '& $image': {
          filter: 'contrast(60%)',
        },
      },
    },

    image: {
      position: 'relative',
      width: '100%',
      height: 100,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundSize: 'cover',
      borderRadius: theme.shape.borderRadiusSmall,
    },

    label: {
      width: '100%',
      color: COLORS.gray.black,
      textAlign: 'center',
    },
  }),
  { name: 'MenuItemImage' }
);
